import { defineComponent } from "vue";
import common from "../core/core";

export default defineComponent({
  components: {},
  data() {
    return {};
  },
  mounted() {},
  computed: {},
  methods: {},
  mixins: [common],
});
